import { axios } from '@/utils/request'

const api = {
  topicList: '/badminapi/activity/topicList',
  activityList: '/badminapi/activity/activityList',
  activityOptions: '/badminapi/activity/activityOptions',
  topicDetail: '/badminapi/activity/topicDetail',
  topicEdit: '/badminapi/activity/topicEdit',
  topicAdd: '/badminapi/activity/topicAdd',
  activityAdd: '/badminapi/activity/activityAdd',
  activityDetail: '/badminapi/activity/activityDetail',
  activityEdit: '/badminapi/activity/activityEdit',
  topicDelete: '/badminapi/activity/topicDelete',
  activityDelete: '/badminapi/activity/activityDelete',
  setRank: '/badminapi/activity/setRank',
  setActivityRank: '/badminapi/activity/setActivityRank',
  setTopicStatus: '/badminapi/activity/setTopicStatus',
  setTopicAllStatus: '/badminapi/activity/setTopicAllStatus',
  commentList: '/badminapi/activity/commentList',
  commentDelete: '/badminapi/activity/commentDelete',
}

export default api


export function getTopicList(parameter) {
  return axios({
    url: api.topicList,
    method: 'get',
    params: parameter
  })
}
export function getActivityList(parameter) {
  return axios({
    url: api.activityList,
    method: 'get',
    params: parameter
  })
}
export function getActivityOptions(parameter) {
  return axios({
    url: api.activityOptions,
    method: 'get',
    params: parameter
  })
}
export function getTopicDetail(parameter) {
  return axios({
    url: api.topicDetail,
    method: 'get',
    params: parameter
  })
}
export function getActivityDetail(parameter) {
  return axios({
    url: api.activityDetail,
    method: 'get',
    params: parameter
  })
}
export function editTopic(parameter) {
  return axios({
    url: api.topicEdit,
    method: 'post',
    data: parameter
  })
}
export function editActivity(parameter) {
  return axios({
    url: api.activityEdit,
    method: 'post',
    data: parameter
  })
}
export function deleteTopic(parameter) {
  return axios({
    url: api.topicDelete,
    method: 'post',
    data: parameter
  })
}
export function deleteActivity(parameter) {
  return axios({
    url: api.activityDelete,
    method: 'post',
    data: parameter
  })
}
export function addTopic(parameter) {
  return axios({
    url: api.topicAdd,
    method: 'post',
    data: parameter
  })
}
export function addActivity(parameter) {
  return axios({
    url: api.activityAdd,
    method: 'post',
    data: parameter
  })
}
export function deleteComment(parameter) {
  return axios({
    url: api.commentDelete,
    method: 'post',
    data: parameter
  })
}
export function getCommentList(parameter) {
  return axios({
    url: api.commentList,
    method: 'post',
    data: parameter
  })
}
export function setRank(parameter) {
  return axios({
    url: api.setRank,
    method: 'post',
    data: parameter
  })
}
export function setActivityRank(parameter) {
  return axios({
    url: api.setActivityRank,
    method: 'post',
    data: parameter
  })
}
export function setTopicStatus(parameter) {
  return axios({
    url: api.setTopicStatus,
    method: 'post',
    data: parameter
  })
}
export function setTopicAllStatus(parameter) {
  return axios({
    url: api.setTopicAllStatus,
    method: 'post',
    data: parameter
  })
}
